/* EditorTabComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require('events').EventEmitter;
const Renderer = require("./EditorTabRenderer");

class EditorTabComponent extends EventEmitter {
    constructor() {
        super();
        this._renderer = new Renderer(this);

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */

    /*******************************************/
    _registerListeners() {

    }

    _unregisterListeners() {
        this.removeAllListeners();
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */

    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown()
            .then(() => {
                this._renderer = undefined;
            });
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */

    /*******************************************/
    _triggerEditorActionIconClicked() {
        this.emit('EditorTabActionIconClicked',
            this._editorAction);
    }

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */

    /*******************************************/
    get editorAction() {
        return this.getEditorAction();
    }

    set editorAction(editorActionConfig) {
        this.setEditorAction(editorActionConfig);
    }

    getEditorAction() {
        return this._editorAction;
    }

    setEditorAction(editorActionConfig) {
        this._editorAction = editorActionConfig;
    }

    get editorActionIconName() {
        return this.getEditorActionIconName();
    }

    set editorActionIconName(name) {
        this.setEditorActionIconName(name);
    }

    getEditorActionIconName() {
        return _.get(this, '_editorAction.iconName', false);
    }

    setEditorActionIconName(name, silent) {
        let old = this._editorActionIconName;
        this._editorActionIconName = name;
        if (!silent) {
            this.emit("EditorActionIconNameChanged", this._editorActionIconName, old);
        }
        return this;
    }

    get editorActionIconType() {
        return this.getEditorActionIconType();
    }

    set editorActionIconType(type) {
        this.setEditorActionIconType(type);
    }

    getEditorActionIconType() {
        return _.get(this, "_editorAction.iconType", "base-icon-gl");
    }

    setEditorActionIconType(type, silent) {
        let old = this._editorActionIconType;
        this._editorActionIconType = type;
        if (!silent) {
            this.emit("EditorActionIconTypeChanged", this._editorActionIconType, old);
        }
        return this;
    }

    get editorActionIconTitle() {
        return this.getEditorActionIconTitle();
    }

    set editorActionIconTitle(title) {
        this.setEditorActionIconTitle(title);
    }

    getEditorActionIconTitle() {
        return _.get(this, "_editorAction.iconTitle", "base-icon-gl");
    }

    setEditorActionIconTitle(title, silent) {
        let old = this._editorActionIconTitle;
        this._editorActionIconTitle = title;
        if (!silent) {
            this.emit("EditorActionIconTitleChanged", this._editorActionIconTitle, old);
        }
        return this;
    }

    get editorIconType() {
        return this.getEditorIconType();
    }

    getEditorIconType() {
        return _.get(this, "_editorIconType", "base-icon-gl");
    }

    set editorIconType(type) {
        return this.setEditorIconType(type);
    }

    setEditorIconType(type, silent) {
        let old = this._editorIconType;
        this._editorIconType = type;
        if (!silent) {
            this.emit("EditorIconTypeChanged", this._editorIconType, old);
        }
        return this;
    }

    get editorIconName() {
        return this.getEditorIconName();
    }

    getEditorIconName() {
        return this._editorIconName;
    }

    set editorIconName(name) {
        return this.setEditorIconName(name);
    }

    setEditorIconName(name, silent) {
        let old = this._editorIconName;
        this._editorIconName = name;
        if (!silent) {
            this.emit("EditorIconNameChanged", this._editorIconName, old);
        }
        return this;
    }

    get title() {
        return this.getTitle();
    }

    getTitle() {
        return this._title;
    }

    set title(tit) {
        return this.setTitle(tit);
    }

    setTitle(tit, silent) {
        let old = this._title;
        this._title = tit;
        if (!silent) {
            this.emit("TitleChanged", this._title, old);
        }
        return this;
    }

    get dirty() {
        return this.getDirty();
    }

    isDirty() {
        if (this.getDirty()) {
            return true;
        } else {
            return false;
        }
    }

    getDirty() {
        return this._dirty;
    }

    set dirty(dirty) {
        return this.setDirty(dirty);
    }

    setDirty(dirty, silent) {
        let old = this._dirty;
        this._dirty = dirty;
        if (!silent) {
            this.emit("DirtyChanged", this._dirty, old);
        }
        return this;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = EditorTabComponent;
